import styled from 'styled-components';
import { theme } from '@jadwalh/ui';

export const BannerWrapper = styled.div`
  width: 100%;
  background-color: #7f1d1d;
  padding: 12px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 48px;

  @media (max-width: 768px) {
    padding: 12px 16px;
    flex-wrap: wrap;
  }

  .reauth-reconnect-btn {
    background-color: ${theme.colours.blackText} !important;
    color: ${theme.colours.white} !important;

    &:hover {
      background-color: ${theme.colours.blackText} !important;
    }
  }
`;

export const BannerText = styled.div`
  color: ${theme.colours.white};
  font-family: ${theme.fonts.Medium};
  font-size: 14px;
  margin: 0;
  text-align: right;
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 12px;
    flex-wrap: wrap;
  }
`;
